export default "__VITE_ASSET__f3d6b8d1__"